import React from 'react'
import PropTypes from 'prop-types'

import { map, values } from 'lodash'

import classes from 'classnames'

import FormGroup from '../components/FormGroup'

import { ui } from '../redux'

const Select = (props) => {
    const {
        label, input, meta, options, placeholder, description, size, isHorizontal, ...otherProps
    } = props
    const { name } = input
    const { error } = meta
    return (
        <FormGroup
            name={ name }
            label={ label }
            error={ error }
            description={ description }
            isHorizontal={ isHorizontal }
        >
            <select
                id={ name }
                className={ classes('form-control', `input-${size}`) }
                { ...otherProps }
                { ...input }
            >
                <optgroup label={ placeholder || label }>
                    { map(options, (label, value) => (
                        <option key={ value } value={ value }>{ label }</option>
                    )) }
                </optgroup>
            </select>
        </FormGroup>
    )
}

Select.propTypes = {
    label        : PropTypes.string,
    placeholder  : PropTypes.string,
    input        : PropTypes.object,
    meta         : PropTypes.object,
    options      : PropTypes.object,
    description  : PropTypes.string,
    size         : PropTypes.oneOf(values(ui.SIZE)),
    isHorizontal : PropTypes.bool
}

export default Select

// { placeholder && <option>{ placeholder }</option> }
